import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed z-[998] bg-black top-0 right-0 w-full h-screen opacity-[0.4]" }, null, -1)
const _hoisted_2 = { class: "md:w-[500px] max-w-[500px] overflow-hidden bg-white border rounded-md shadow-md" }
const _hoisted_3 = { class: "flex items-center justify-between px-5 py-3 text-gray-700 border-b" }
const _hoisted_4 = { class: "text-sm capitalize" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "px-5 py-6 text-gray-700 bg-gray-200 border-b max-h-[80vh] overflow-y-scroll" }
const _hoisted_8 = { class: "flex items-center justify-between px-5 py-3" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!
  const _component_InputImage = _resolveComponent("InputImage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "fixed z-[999] flex justify-center items-center w-screen h-screen top-0 right-0",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }, [
      _createElementVNode("div", {
        ref: "modalContent",
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_InputText, {
                label: "Nama Orang Tua",
                keyValue: "parentName",
                value: _ctx.data?.parentName,
                onUpdate: _ctx.updateValue,
                required: true
              }, null, 8, ["value", "onUpdate"]),
              _createVNode(_component_InputText, {
                label: "NIM Anak",
                keyValue: "childNim",
                value: _ctx.data?.childNim,
                onUpdate: _ctx.updateValue,
                required: true
              }, null, 8, ["value", "onUpdate"]),
              _createVNode(_component_InputText, {
                label: "No Whatsapp",
                keyValue: "noWhatsapp",
                value: _ctx.data?.noWhatsapp,
                onUpdate: _ctx.updateValue,
                required: true
              }, null, 8, ["value", "onUpdate"]),
              _createVNode(_component_InputCheckbox, {
                label: "Bersedia menjadi Pengurus IOM?",
                keyValue: "staff",
                value: _ctx.data?.options?.staff,
                onUpdate: _ctx.updateValue,
                required: true
              }, null, 8, ["value", "onUpdate"]),
              _createVNode(_component_InputCheckbox, {
                label: "Bersedia menjadi Orang Tua Asuh?",
                keyValue: "foster",
                value: _ctx.data?.options?.foster,
                onUpdate: _ctx.updateValue,
                required: true
              }, null, 8, ["value", "onUpdate"]),
              _createVNode(_component_InputImage, {
                label: "Picture",
                keyValue: "picture",
                value: _ctx.data?.picture,
                onUpdate: _ctx.updateValue,
                required: true
              }, null, 8, ["value", "onUpdate"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "px-3 py-1 text-sm text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none"
              }, " Cancel "),
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.isLoading,
                class: "px-3 py-1 text-sm text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none"
              }, _toDisplayString(_ctx.isLoading ? 'Loading...' : 'Save'), 9, _hoisted_9)
            ])
          ], 32)
        ])
      ], 512)
    ])
  ], 64))
}